import React, { createContext, useCallback, useContext, useState } from 'react';

const SuiteContext = createContext();

export const SUITE_OPTIONS = {
  YUGO: 'YUGO',
  COLIVING: 'COLIVING',
};

export const SuiteProvider = ({ children }) => {
  const [suiteConfig, setSuiteConfig] = useState(SUITE_OPTIONS.YUGO);

  return (
    <SuiteContext.Provider
      value={{
        suiteConfig,
        setSuiteConfig,
      }}
    >
      {children}
    </SuiteContext.Provider>
  );
};

export const useSuiteContext = () => useContext(SuiteContext);

export const useReplaceSuiteStudentToCustomer = () => {
  const { suiteConfig } = useContext(SuiteContext);

  const replaceSuiteStudentToCustomer = useCallback(
    (student, customer) => {
      if (suiteConfig === SUITE_OPTIONS.COLIVING) return customer;
      return student;
    },
    [suiteConfig]
  );

  return replaceSuiteStudentToCustomer;
};
